// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAsq5uUGiyG6K0NdmJhkMR_MP7u7rMfyDY",
  authDomain: "league-af940.firebaseapp.com",
  projectId: "league-af940",
  storageBucket: "league-af940.firebasestorage.app",
  messagingSenderId: "1010018980693",
  appId: "1:1010018980693:web:4677cffab6c5bfc00155dc",
  measurementId: "G-ZVES0PSPGY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore, Auth, Functions, and Storage
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);

// Set persistent authentication
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase auth persistence set to LOCAL');
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });